/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockBrandPopupCtrl
 */
angular.module('mercury.modules.stock.brand')
.controller('StockBrandPopupCtrl', ["dialog", "ngToast", "onAdd", "$scope", "StockBrands", "$timeout", function(dialog, ngToast, onAdd, $scope, StockBrands, $timeout) {
  $scope.newBrand = {
    name: ''
  };

  $scope.brandFilter = {name: ''};

  $scope.edit = false;

  $scope.selected = null;

  $scope.brands = StockBrands.getAllActive();

  $scope.save = function() {
    dialog.onClose($scope.selected, customAdded);
    dialog.close();
  };

  $scope.setSelected = function(selectedBrand) {
    $scope.selected = selectedBrand;
  };

  $scope.create = function(form) {
    form.$setSubmitted();
    if (form.$invalid) {
      ngToast.dismiss();
      ngToast.danger('Please fix the errors with the new unit');
      return;
    }

    StockBrands.create($scope.newBrand)
    .then(function(result) {
      onAdd(result);
      $scope.brands.unshift(result);
      $scope.selected = result;
      $scope.edit = false;

      $timeout(function() {
        $('#brandList').animate({
          scrollTop: $('#brand_' + result.id).offset().top
        }, 500);
      });

      //Reset the model incase they add another.
      $scope.newBrand = {
        name: ''
      };
    });
  };
}]);
